import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=4ae22afc&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=4ae22afc&prod&scoped=true&lang=css&"
import style1 from "../styles/common.css?vue&type=style&index=1&id=4ae22afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae22afc",
  null
  
)

export default component.exports